import React from 'react';
import { useEffect, useState, useRef, useMemo } from 'react'
import Button from '../common/ui-components/input/Button';
import styles from '../../styles/modules/components/SelfServe/enter-address.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { GetPincodeDetails } from '../../api/selfserve';
import {
    changeProgress, updateProcessType, updateSrCapacityData, updateAppointmentDate,
    updateCityDetails, updateAddressDetails, changeTrackerState,
    pushToTicketList,previousStepProgress, changeEdit
} from '../../redux/actions/selfserveActions';
import Moment from 'moment';
import { enterAddress } from '../../tracking/selfserveTracking';
import { addAppRenderParams, appointmentDateSlot1, appointmentDateSlot2, appointmentFormat, isSelectedSlotValid, isSelectedSlotValidHomeCare, shouldShowTimeSlots } from '../../utils/selfserve';
import DeviceDetail from '../selfserve/DeviceDetail';
import { DEFAULT_TIME_SLOTS, AFTRENOON_TIME_SLOTS } from '../../constants/index';
import SlotSelection from '../cart/SlotSelectionV2'
import { HOMECARE_PLAN_LIST } from '../../constants/index';
import {AddressSelector} from '@/components/address/AddressSelector'
import { AddressPopup } from '@/components/address/AddressPopup';
import { changeCartEdit } from '../../redux/actions/customerActions';
import { updateVerify } from '../../redux/actions/cartActions';
import { cleverTapTrigger } from '../../tracking/segment';
import { useRouter } from 'next/router';

interface ReduxStateProps {
    selfserveReducer: any,
    customer: any,
    cart: any

}


interface MainProps {

    setPageLoading: (data:Boolean) => void
}


type Props = ReduxStateProps & MainProps;

const EnterAddress = (props: Props) => {
    const [isAMC, setIsAMC] = useState<boolean>(false);
    const [addressData] = React.useState<any>(props.selfserveReducer.customerDetails.address);
    const [minDateOne, setMinDateOne] = React.useState<any>(Moment(appointmentDateSlot1(), 'DD/MM/YYYY').toDate());
    const [minDateTwo, setMinDateTwo] = React.useState<any>(Moment(appointmentDateSlot1(), 'DD/MM/YYYY').toDate());

    // Date and time Slot
    const [slotOne, setSlotOne] = React.useState<any>(props.selfserveReducer.appointmentProcessType.appointmentDate1 ? Moment(props.selfserveReducer.appointmentProcessType.appointmentDate1, 'DD/MM/YYYY').toDate() : minDateOne);
    const [slotTwo, setSlotTwo] = React.useState<any>(props.selfserveReducer.appointmentProcessType.appointmentDate1 ? Moment(props.selfserveReducer.appointmentProcessType.appointmentDate1, 'DD/MM/YYYY').toDate(): minDateTwo);
    // Pincode State
    const [pincodeValue] = React.useState<string>(addressData.pincode ? addressData.pincode : '');
    // City and State state
    const [cityValue, setCityValue] = React.useState<string>(addressData.city);
    const [StateValue, setStateValue] = React.useState<string>(addressData.state);

    const [timeSlotOne, setTimeSlotOne] = React.useState<any>('');
    const [timeSlotTwo, setTimeSlotTwo] = React.useState<any>({ key: props.selfserveReducer.appointmentProcessType.appointmentTimeSlot2, value: props.selfserveReducer.appointmentProcessType.appointmentTimeSlot2, text: props.selfserveReducer.appointmentProcessType.appointmentTimeSlot2 });

    // Blocks next button according to capacity check
    const [blockButton, setBlockButton] = React.useState<boolean>(false);
    // Block Next button according to pincode
    const [blockButtonPincode, setBlockButtonPincode] = React.useState<boolean>(false);
    const [calendarError, setCalendarError] = React.useState<string>('');
    const [slotsAvailable, setSlotsAvailable] = useState<boolean>(true)
    const [mode, setMode] = useState<string>('');
    const [editAddressId, setEditAddressId] = useState<string>('')
    const [editAddress, setEditAddress] = useState<boolean>(false)
    const [newAddress, setNewAddress] = useState<boolean>(false)
    const [pincode, setPincode] = useState<any>('')
    const [displayAddress, setDisplayAddress] = useState<any>([])
    const [totalAdressLength,setTotalAddressLength] = useState(0)
    const isMountedOne = useRef(false);
    const activePincodeRequests = useRef(0);
    const latestPincodeRequestId = useRef(0);
    const dispatch:any = useDispatch()
    const [isMobile, setMobile] = React.useState<boolean>(true)
    const [onlyThree, setOnlyThree] = useState<boolean>(true)
    const [openId, setOpenId] = useState(null)
    const router = useRouter()

    useEffect(() => {
        window.innerWidth < 768 ?
            setMobile(true)
            :
            setMobile(false)
    });
    // pincode API call
    const pinCodeApi: any = (data) => (GetPincodeDetails({

        "application": "website",
        "data": JSON.stringify(data)

    }).then((res: any) => {
        return res.data
    })).catch(() => {
        addAppRenderParams(router)
    })

    const resetDateTime = (tslotTwo) => {
        setSlotOne(props.selfserveReducer.slotAvailabilityData?.firstAvailableDate)
        setSlotTwo(props.selfserveReducer.slotAvailabilityData?.secondAvailableDate)
        setTimeSlotOne('')
        if (tslotTwo && tslotTwo[0]) {
            setTimeSlotTwo(tslotTwo[0])
        }
    }

    const startPincodeRequest = () => {
        activePincodeRequests.current += 1;
        latestPincodeRequestId.current += 1;
        setBlockButtonPincode(true);
        props.setPageLoading(true);
        return latestPincodeRequestId.current;
    }

    const finishPincodeRequest = () => {
        activePincodeRequests.current = Math.max(0, activePincodeRequests.current - 1);
        if(activePincodeRequests.current === 0){
            setBlockButtonPincode(false);
            props.setPageLoading(false);
        }
    }

    const { previousStepList, editScreen } = props.selfserveReducer
    useEffect(() => {
        if(isMountedOne.current){
        if(props.selfserveReducer.appointmentProcessType.processType === 'AMC' && props.selfserveReducer.slotAvailabilityData?.dateSlotMapping){
            let dateSlotMapping: any = props.selfserveReducer.slotAvailabilityData?.dateSlotMapping
            let mappings: any = Object.keys(props.selfserveReducer.slotAvailabilityData?.dateSlotMapping).sort()
            let tslotTwo: any = props.selfserveReducer.slotAvailabilityData?.dateSlotMapping[mappings[0]]
            let selected_tslot1 = timeSlotOne ? timeSlotOne.key : null
            let selected_tslot2 = timeSlotTwo ? timeSlotTwo.key : null
            let selected_date1: any = props.selfserveReducer.appointmentProcessType.appointmentDate1 ? Moment(props.selfserveReducer.appointmentProcessType.appointmentDate1, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
            let selected_date2: any = props.selfserveReducer.appointmentProcessType.appointmentDate2 ? Moment(props.selfserveReducer.appointmentProcessType.appointmentDate2, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
            if(selected_tslot1 && selected_date1 && dateSlotMapping[selected_date1] && !dateSlotMapping[selected_date1].some(el => el.key === selected_tslot1)){
                setTimeSlotOne('');
            }
            if(selected_tslot2 && selected_date2 && dateSlotMapping[selected_date2] && !dateSlotMapping[selected_date2].some(el => el.key === selected_tslot2)){
                setTimeSlotTwo(dateSlotMapping[selected_date2] ? dateSlotMapping[selected_date2][0] : null);
            }
            setMinDateTwo(props.selfserveReducer.slotAvailabilityData?.secondAvailableDate)
            setMinDateOne(props.selfserveReducer.slotAvailabilityData?.firstAvailableDate)

            if (!props.selfserveReducer.appointmentProcessType.appointmentDate1){
                setTimeSlotOne('')
                setSlotOne(props.selfserveReducer.slotAvailabilityData?.firstAvailableDate)
            } else {
                if (!dateSlotMapping[selected_date1]){
                    resetDateTime(tslotTwo)
                }
            }
            if (!props.selfserveReducer.appointmentProcessType.appointmentDate2){
                if (tslotTwo && tslotTwo[0]) {
                    setTimeSlotTwo(tslotTwo[0])
                }
                setSlotTwo(props.selfserveReducer.slotAvailabilityData?.secondAvailableDate)
            } else {
                if (!dateSlotMapping[selected_date2]){
                    resetDateTime(tslotTwo)
                }
            }
            setSlotsAvailable(true)
            if(props.selfserveReducer.slotAvailabilityData?.firstAvailableDate > Moment(props.selfserveReducer.slotAvailabilityData?.tPlus3Date).toDate()){
            }
        }
        else{
            // AMC static dates flow
            setSlotsAvailable(false)
        }
    }
    else{
        isMountedOne.current = true;
    }
    }, [props.selfserveReducer.slotAvailabilityData.dateSlotMapping, props.selfserveReducer.slotAvailabilityData.error])

    useEffect(() => {
        if(props.selfserveReducer.appointmentProcessType.processType === 'AMC' && ['SLOT_NOT_FOUND'].includes(props.selfserveReducer.slotAvailabilityData?.error)) {
            setSlotsAvailable(false)
        }
        cleverTapTrigger('Slot Selection Viewed', {'source':'selfserve', 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})

        dispatch(changeTrackerState(3));
        window.scrollTo({top:0,left:0,'behavior': 'smooth'});
        if (addressData.pincode) {
            const requestId = startPincodeRequest();
            let data = {
                "token_id": props.selfserveReducer.token_id,
                "osid": props.selfserveReducer.planDetails.osid,
                'pincode': addressData.pincode
            }
            if (props.selfserveReducer?.serviceRequests[0]?.selected_cover?.cover_details?.[0]?.root_product_type_name) {
                data['selected_cover'] = props.selfserveReducer?.serviceRequests[0]?.selected_cover?.cover_details?.[0]?.root_product_type_name
            }
            addressData.pincode && pinCodeApi(data).then(success => {
                if(!success || requestId !== latestPincodeRequestId.current){
                    finishPincodeRequest();
                    return;
                }
                if(success.process_type !== 'AMC'){
                    setMinDateOne(Moment(appointmentDateSlot1('Non-AMC'), 'DD/MM/YYYY').toDate());
                    setMinDateTwo(Moment(appointmentDateSlot2('Non-AMC'), 'DD/MM/YYYY').toDate());
                }
                if(success.sr_capacity_data.capacity_check_required && success.sr_capacity_data.appointment_date){
                    // setting date values from values recieved in API
                    setMinDateOne(Moment(success.sr_capacity_data.appointment_date, 'DD MMM YYYY').toDate());
                    setMinDateTwo(Moment(success.sr_capacity_data.appointment_date_1, 'DD MMM YYYY').toDate());
                }
                // Blocking Next button is capaicty is not available
                setBlockButton(success.sr_capacity_data.capacity_check_required ? !success.sr_capacity_data.capacity_available : false)
                if(!cityValue){
                    setCityValue(success.city)
                }
                if(!StateValue){
                    setStateValue(success.state)
                }
                dispatch(updateSrCapacityData(success.sr_capacity_data));
                const processTypeData = {
                    'process_type': success.process_type
                }
                dispatch(updateCityDetails({city:success.city, state:success.state, disclaimers:success.disclaimers}));
                if(!HOMECARE_PLAN_LIST.includes(props.selfserveReducer.parentPlanDetails.plan_name)){
                    setIsAMC(success.process_type === 'AMC'? true: false);
                }
                dispatch(updateProcessType(processTypeData, ()=>{
                    finishPincodeRequest();
                }));
            }).catch(() => {
                finishPincodeRequest();
            })
        } else {
            setBlockButtonPincode(false);
            props.setPageLoading(false);
        }
    }, [addressData])

    useEffect(()=>{
        if(!editAddressId || !pincode){
            return;
        }
        const requestId = startPincodeRequest();
        let newData = {
            "token_id": props.selfserveReducer.token_id,
            'osid': props.selfserveReducer.planDetails.osid,
            'pincode': pincode
        }
        if (props.selfserveReducer?.serviceRequests[0]?.selected_cover?.cover_details?.[0]?.root_product_type_name) {
            newData['selected_cover'] = props.selfserveReducer?.serviceRequests[0]?.selected_cover?.cover_details?.[0]?.root_product_type_name
        }
        pinCodeApi(newData).then(success => {
            if(!success || requestId !== latestPincodeRequestId.current){
                finishPincodeRequest();
                return;
            }
            setSlotOne(null)
            setSlotTwo(null)
            setCalendarError('');
            const appointmentData = {
                appointment_date_1: null,
                appointment_date_2: null,
                appointment_slot_1: (new Date().getHours() < 14) ? "10AM - 2PM" : "2PM - 6PM",
                appointment_slot_2: (new Date().getHours() < 14) ? "10AM - 2PM" : "2PM - 6PM",
            }
            dispatch(updateAppointmentDate(appointmentData));
            setBlockButton(success.sr_capacity_data.capacity_check_required ? !success.sr_capacity_data.capacity_available : false)
            setCityValue(success.city);
            setStateValue(success.state);

            if(success.sr_capacity_data.capacity_check_required && success.sr_capacity_data.appointment_date){
                // if new date values received from API setting it to minDateOne and minDateTwo
                setMinDateOne(Moment(success.sr_capacity_data.appointment_date, 'DD MMM YYYY').toDate());
                setMinDateTwo(Moment(success.sr_capacity_data.appointment_date_1, 'DD MMM YYYY').toDate());

            } else {
                // else setting minDateOne and minDateTwo to default values
                if(success.process_type !== 'AMC'){
                    setMinDateOne(Moment(appointmentDateSlot1('Non-AMC'), 'DD/MM/YYYY').toDate());
                    setMinDateTwo(Moment(appointmentDateSlot2('Non-AMC'), 'DD/MM/YYYY').toDate());

                }else{
                    setMinDateOne(Moment(appointmentDateSlot1(), 'DD/MM/YYYY').toDate());
                    setMinDateTwo(Moment(appointmentDateSlot2(), 'DD/MM/YYYY').toDate());
                }
            }

            dispatch(updateCityDetails({city:success.city, state:success.state, lockdown_info:success.lockdown_info}));
            if(editAddressId!==''){
                let add_data = props.customer.address.find(item => item.id === editAddressId)
                const addressData = {
                    address: { address: add_data?.address|| '', address2: "", pincode: add_data?.pincode||'', city: add_data?.city||'', state: add_data?.state|| '', id: add_data?.id||'', landmark: add_data?.landmark||'', label: add_data?.label||'', lat: add_data?.lat||'', lng:add_data?.lng||''  }
                };
                dispatch(updateAddressDetails(addressData));
                dispatch(updateSrCapacityData(success.sr_capacity_data));
            }
            const processTypeData = {
                'process_type': success.process_type
            }
            if(!HOMECARE_PLAN_LIST.includes(props.selfserveReducer.parentPlanDetails.plan_name)){
                setIsAMC(success.process_type === 'AMC'? true: false);
            }
            dispatch(updateProcessType(processTypeData, ()=>{
                finishPincodeRequest();
            }))
        }).catch(() => {
            finishPincodeRequest();
        })
    },[editAddressId])

    const handleSlotOneDate = (value) => {
        // value = '2021-08-04'
        const dateOne = Moment(value, "YYYY-MM-DD").format('DD/MM/YYYY')
        setSlotOne(Moment(dateOne, 'DD/MM/YYYY').toDate())
        let d_2 = slotTwo ? slotTwo : minDateTwo
        if((isAMC && props.selfserveReducer.slotAvailabilityData.dateSlotMapping) || HOMECARE_PLAN_LIST.includes(props.selfserveReducer?.planDetails?.category_type)){
            onDateSelectOne()
        }

        if(['AMC'].includes(props.selfserveReducer.appointmentProcessType.processType)){
            if(dateOne && d_2 && Moment(d_2).format('DD/MM/YYYY') == dateOne){

                setCalendarError(''/* 'Please select a date that is later than the Slot 1 date' */)

            } else if (dateOne && d_2 && (d_2 < Moment(dateOne, 'DD/MM/YYYY'))){
                setCalendarError(''/* 'Please select a date that is later than the Slot 1 date' */)
            } else {

                setCalendarError('')

            }
        }
    }

    const onDateSelectOne = () => {
        setTimeSlotOne('')
    }

    const handleTimeSlotOne = (value) => {
        if(value !== ''){
            setTimeSlotOne({key: value, text: value, value: value});
        } else{
            setTimeSlotOne('');
        }
    }
    const handleButtonClick = (e) => {
        // dispatch(changeProgress(18));

        enterAddress(); //gtm tracking event
        e.preventDefault();

        // Adding AddressTwo value in Redux

        if(!props.selfserveReducer.slotAvailabilityData?.error){        
            const data = {
                appointment_date_1: slotOne ? Moment(slotOne).format('DD/MM/YYYY') :  Moment(minDateOne).format('DD/MM/YYYY'),
                appointment_slot_1: timeSlotOne?.text,
            }
            if(['AMC'].includes(props.selfserveReducer.appointmentProcessType.processType)){
                dispatch(updateAppointmentDate(data));
            }
        }
        dispatch(changeProgress(8));
        cleverTapTrigger('Slot Selection - All Slots Selected', {
                'source':'selfserve',
                'pincode':pincodeValue,
                'category_name':props.selfserveReducer?.planDetails?.category_type,
                'slots':[appointmentFormat(slotOne,timeSlotOne?.value),appointmentFormat(slotTwo,timeSlotTwo?.value)].join(','),
                'service':props.selfserveReducer?.planDetails?.plan_title,
                'category': props.selfserveReducer?.planDetails?.category,
                'product_type': props.selfserveReducer?.planDetails?.product_type
        })
    }
    
    const updateAddressId = (id, action="") => {
        if(blockButtonPincode){
            return;
        }
        if(action==="edit" || action==="verify")
        {
            setOpenId(id)
            let add_data = props.customer.address.find(item => item.id === id)
            const addressData = {
                address: { address: add_data.address, address2: "", pincode: add_data.pincode, city: add_data.city, state: add_data.state, id: add_data.id, landmark: add_data.landmark, label: add_data.label, lat: add_data.lat, lng:add_data.lng  }

            };
            setPincode(add_data.pincode)
            dispatch(updateAddressDetails(addressData));
        }
        else if(editAddressId!==id && id !== '')
        {
            const b :any =document.querySelector(`div#slotpicker`)
            b ? b.scrollIntoView({behavior: 'smooth',block: 'nearest'}): setTimeout(() => {
                    const b :any =document.querySelector(`div#slotpicker`)
                   b && b.scrollIntoView({behavior: 'smooth',block: 'nearest'})
            }, 2000)
            setEditAddressId(id)
            let add_data = props.customer.address.find(item => item.id === id)
            const addressData = {
                address: { address: add_data.address, address2: "", pincode: add_data.pincode, city: add_data.city, state: add_data.state, id: add_data.id, landmark: add_data.landmark, label: add_data.label, lat: add_data.lat, lng:add_data.lng  }

            };
            setPincode(add_data.pincode)
            dispatch(updateAddressDetails(addressData));   
        }
      }
    
    const updateEditMode = (value, type, details: any = {}, status: string = "") => {
        if(value){
            cleverTapTrigger(" Address Popup Open",{pincode: details.pincode||'', city: details.city||'', address: details.address||'', type: type})
          } else{
            cleverTapTrigger(" Address Popup Close",{pincode: details.pincode|| '', city: details.city||'', address: details.address||'', type: type, value: status})
          }
        if(isMobile===true){
            dispatch(changeProgress(18));
            if(type==="edit" || type==="verify") 
            {
                dispatch(changeEdit(true))
                dispatch(changeCartEdit(false))
                setMode(type)
            }
        }
        else{
            if(type==="edit" || type==="verify") {
            setEditAddress(value),
            setMode(type)
            } else setNewAddress(value)
        }
        if(!blockButtonPincode){
            props.setPageLoading(false)
        }
      }
    useEffect(()=>{
        let display_data = props.customer.address.filter(a => a.is_verified && a.lat && a.lng);
        setTotalAddressLength(display_data.length)
         display_data = onlyThree ? display_data.sort((a,b)=>b.id - a.id ).slice(0, isMobile ? 2 : 3) : display_data.sort((a,b)=>b.id - a.id )
        setDisplayAddress(display_data)
    },[props.customer.address,onlyThree,isMobile])

    const  addressSelectedEvent=(address)=>{
        cleverTapTrigger("Address Selected",{...address, source:'Selfserve', 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})}
    
    let all_labels = props.customer.address.map((item)=>{ return item.label; })

    const slotSelectionPending = useMemo(() => {
        let slotsData = props.selfserveReducer.slotAvailabilityData?.dateSlotMapping;
        let pending = slotsAvailable && ['AMC'].includes(props.selfserveReducer.appointmentProcessType.processType);
        if (HOMECARE_PLAN_LIST.includes(props.selfserveReducer?.planDetails?.category_type)) {
            slotsData = props.selfserveReducer.slotSelectionData?.[0]?.slots; // Homecare static dates are stored here
            pending = pending && !isSelectedSlotValidHomeCare(slotsData, slotOne, timeSlotOne);
        } else {
            pending = pending && !isSelectedSlotValid(slotsData, slotOne, timeSlotOne);
        }
        return pending;
    }, [
        slotsAvailable,
        props.selfserveReducer.slotAvailabilityData?.dateSlotMapping,
        props.selfserveReducer.appointmentProcessType.processType,
        props.selfserveReducer.slotSelectionData?.[0]?.slots,
        slotOne,
        timeSlotOne,
    ]);

    return (
        <div className={`${styles.address_parent} selfserve_addresspop`} id="selfserve-details">
            <div className={`${styles.address_selector_div} ${styles.address_padding} container`}>
            <div className={styles.address_heading}>
                <h6>Select Service Address</h6>
               {isMobile && <p className={styles.new_address} onClick={() => { updateEditMode(true, "new",{}) }}>+ ADD NEW ADDRESS</p>}
            </div>
                <div className={`${styles.address_selector_card} row`}>
                
                {
                  displayAddress.map((item)=>{
                    return <AddressSelector key={item.id} isLoading={blockButtonPincode} updateVerify={(value) => dispatch(updateVerify(value))} updateEditMode={updateEditMode} editAddressId={editAddressId} id={item.id} label={item.label} verified={item.is_verified && item.lat && item.lng} full_address={item.address} updateEditAddressId={updateAddressId} addressSelectedEvent={addressSelectedEvent} {...item}/>
                  })
                }
                </div>
                { (totalAdressLength - (isMobile ? 2 : 3)) > 0 && onlyThree && <p className={styles.more_address} onClick={()=>{ setOnlyThree(false) }}>+{ totalAdressLength - (isMobile ? 2 : 3) } more address</p> }
                { (totalAdressLength - (isMobile ? 2 : 3)) > 0 && !onlyThree && <p className={styles.more_address} onClick={() => { setOnlyThree(true); let element = document.getElementById('selfserve-details'); if(element){ window.scrollTo({top:element.getBoundingClientRect().top+window.pageYOffset-200}) } }}>Show Less</p>}
                {!isMobile && <p className={styles.new_address} onClick={() => { updateEditMode(true, "new",{}) }}>+ ADD NEW ADDRESS</p>}
              </div>
                {
                    editAddress && <AddressPopup updateVerify={(value) => dispatch(updateVerify(value))} verify={props.cart.verify} updateEditMode={updateEditMode} isOpen={editAddress && editAddressId ? true : false} mode={mode} data={props.customer.address.find(item => item.id === openId)} id={openId} token={props.customer.customer_token} existing_label={all_labels} isSelfserve={true} {...props}/>
                }
                {
                    newAddress && <AddressPopup updateVerify={()=>{}} updateEditMode={updateEditMode} isOpen={newAddress ? true : false} mode={"new"} token={props.customer.customer_token} existing_label={all_labels} isSelfserve={true} {...props}/> 
                }

            {props.selfserveReducer.landed_on_page === 'address' &&
                <DeviceDetail />
            }

            {props.selfserveReducer.cityDetails.disclaimers && props.selfserveReducer.cityDetails.disclaimers.map((disclaimer, index) => {
               return <p key={index} className={`${styles.lockdowninfo} lapsed`}>{disclaimer}</p>
            })}

        {pincode && slotsAvailable && ['AMC'].includes(props.selfserveReducer.appointmentProcessType.processType) && (<div className={`${styles.slot_padding} container`}>

            {/* Disclaimers */}
            <h6 className={styles.slot_heading}>Select Visit Date</h6>
            {props.selfserveReducer.srCapacityData.sr_capacity_disclaimers && props.selfserveReducer.srCapacityData.sr_capacity_disclaimers.length != 0 && props.selfserveReducer.srCapacityData.sr_capacity_disclaimers.map((item, index) => {return <p key={index} className={`${styles.disclaimer} lapsed`}>{item}</p>})}      
              <SlotSelection callback={{}} selectionType={"selfServe"} isAgent={false} handleSlotDate={handleSlotOneDate} handleTimeSlotChange={handleTimeSlotOne} />
            </div>)}
            <div className={commonStyles.button_actions_sticky} data-varient='sticky'>
                {/* PREVIOUS BUTTON */}
                {previousStepList.length &&
                    <Button
                        disabled={props.selfserveReducer.landed_on_page === 'address'}
                        className={commonStyles.cart_btn}
                        text={'Previous'}
                        variant='secondary'
                        onClick={() => {
                            // dispatch(changeProgress(props.selfserveReducer.addressPageFrom));
                            dispatch(previousStepProgress());
                        }}
                    />
                }

                <Button
                    // disabling if slots available and slots not selected
                    disabled={blockButton || Boolean(calendarError) ||blockButtonPincode || slotSelectionPending || !editAddressId }
                    className={commonStyles.cart_btn}
                    text={!editScreen.isEditing ? 'Next' : 'Done'}
                    variant='primary'
                    onClick={(e) => {handleButtonClick(e)}}
                />

            </div>

        </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
        customer: state.customerReducer,
        cart: state.cart
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(EnterAddress);
